import React, { useEffect, useState } from 'react';

import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import Header from '../../newFront/header/Header';
import Typography from '@mui/material/Typography';
import { API_URL } from '../../Constants';



let apiUrl = API_URL;

const handleCommerceLoggin = () => {
    window.location = '/commerce-loggin';
}

const handleAdminLoggin = () => {
    window.location = '/pending';
}

function BuildingPage() {


    return (
        <React.Fragment>
            <CssBaseline />
            <Header isLoggedIn={false} />
            <Container maxWidth="md">

                <br />
                <br />
                <br />
                <br /><br /><br /><br />



                <Typography variant="h4" component="div" gutterBottom align='center' style={{ color: '#A1A1A1' }}>
                    ¡Trabajamos para darte una mejor experiencia!

                </Typography>

                <br />
                <br />

                <Typography variant="h2" component="div" gutterBottom align='center' style={{ color: '#A1A1A1' }}>
                    PÁGINA
                </Typography>

                <Typography variant="h2" component="div" gutterBottom align='center' style={{ color: '#A1A1A1' }}>
                    EN CONSTRUCCIÓN...
                </Typography>
                <br />
                <br />
                <div align='center'>
                    <img src="https://user-images.githubusercontent.com/43441715/164540281-6b7f5ea5-51dc-4406-ab76-5a24e772748d.gif" width="30%" height="30%"  />

                </div>

            </Container>
        </React.Fragment>

    );
}

export default BuildingPage;